<template>
  <v-container class="justify-center" fluid fill-height primary>
    <v-row class="justify-center white--text flex-row-reverse">
      <v-col class="border col-8 col-sm-4">
        <v-img
          contain
          min-height="150px"
          max-height="360px"
          class=""
          src="./../assets/head.svg"
        />
      </v-col>

      <v-col class="mx-4 mt-auto col-12 col-md-6">
        <p
          v-html="bemVindo.titulo"
          class="border mb-md-10 text-h5 text-sm-h3 text-center text-md-h3 font-weight-bold"
        ></p>
        <p
          v-html="bemVindo.texto"
          class="border mb-8 text-body-1 text-center text-sm-h5 font-weight-regular"
        ></p>
        <v-btn
          block
          large
          depressed
          rounded
          class="text-center"
          router
          to="/cadastro"
        >
          <span class="font-weight-bold"> Clique aqui para começar </span>
        </v-btn>

        <v-btn
          dark
          block
          large
          rounded
          outlined
          class="text-center mt-2 mt-sm-4"
          depressed
          router
          to="/dicas"
        >
          Dicas de saúde
        </v-btn>
      </v-col>
    </v-row>
    <!-- <v-row class="justify-center align-center">
      <v-col class="col-12 col-md-6"> </v-col>
    </v-row> -->
  </v-container>
</template>

<script>
export default {
  data: () => ({
    startFormPage: "/cadastro",
    bemVindo: {
      titulo: "Bem-vindo ao MentalPro",
      texto: `Cansaço, irritabilidade, insônia podem ser sintomas de estresse. <br/> Visando saber como você está criamos um aplicativo sobre sua saúde mental, que tal experimentar? É bem rápido, no fim, informações e dicas que podem ajudar.`,
    },
  }),

  async beforeCreate() {
    setTimeout(() => this.$root.$emit("spinner::hide"), 2000);
  },
  created() {
    if (process.env.NODE_ENV === "production") {
      this.$firebase.analytics().logEvent("screen_view", {
        screen_name: "home",
      });
    }
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style>
.container.fill-height > .row {
  flex: 1 1 100%;
  max-width: 100%;
}
.v-btn {
  text-transform: none;
}
</style>
